import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InstallationMenuDetailPage } from './installation-menu-detail.page';

const routes: Routes = [
  {
    path: '',
    component: InstallationMenuDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InstallationMenuDetailPageRoutingModule {}
